import { CashIcon, WaitingIcon } from 'assets/icons';
import { format } from 'date-fns';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { FC, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { AgentService } from 'services/AgentService';
import { DropDown, MenuDirection, MenuItem } from 'ui/DropDown';
import { Spinner } from 'ui/Spinner';
import { ROUBLE_SIGN } from 'utils/settings';
import { RefillBalanceModal } from './RefillBalanceModal';
import { formatAmount } from 'utils/helpers';
import { AxiosError } from 'axios';
import { BaseError } from 'types';
import { FinanceService } from 'services/FinanceService';

export const BalanceInformer: FC = () => {
  const { tab } = useParams();
  const dispatch = useAppDispatch();
  const actions: MenuItem[] = [
    {
      title: 'Пополнить счет',
      action: () => {
        dispatch(
          modalActions.handleOpenModal({
            content: <RefillBalanceModal />,
            options: {
              title: 'Укажите сумму пополнения',
              withCloseButton: false,
              modalClassName: 'w-full sm:w-[650px] !overflow-visible sm:min-h-72',
              contentClassName: '!overflow-visible',
            },
          })
        );
        // refetch();
        // toast.warning('Обновление баланса...');
      },
    },
    {
      title: 'Обновить баланс',
      action: () => {
        refetch();
        toast.warning('Обновление баланса...', {
          icon: <WaitingIcon className="h-5 w-5 self-center !text-warning" />,
        });
      },
    },
  ];

  const {
    isFetching: isVirtualAccountFetching,
    data: virtualAccountData,
    refetch,
  } = useQuery(['getVirtualAccount'], () => FinanceService.getVirtualAccount(), {
    onSuccess() {
      setvirtualAccountIsLoaded(true);
      virtualAccountIsLoaded && toast.success('Баланс успешно обновлен');
    },
  });

  const { isFetching: isBudgetFetching, data: budgetData } = useQuery(
    ['getBudget'],
    () => AgentService.getBudget(),
    {
      onSuccess() {
        setvirtualAccountIsLoaded(true);
        virtualAccountIsLoaded && toast.success('Баланс успешно обновлен');
      },
      onError: (data: AxiosError<BaseError>) => {
        data.response?.data.errors
          ? Object.values(data.response?.data.errors).forEach((errors) =>
              errors.forEach((message) => toast.error(message))
            )
          : toast.error(data.response?.data.detail);
      },
    }
  );

  const virtualAccount = virtualAccountData?.data;
  const balance =
    String((virtualAccount?.holdingAmount ?? 0) + (virtualAccount?.balance ?? 0)).replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ' '
    ) ?? 0;

  const [virtualAccountIsLoaded, setvirtualAccountIsLoaded] = useState<boolean>(false);

  return (
    <section className="mb-8 flex items-center gap-5 sm:max-w-full">
      <section className="flex min-w-[620px] items-center rounded-[10px] p-5 shadow-3xl">
        <CashIcon width={160} />
        {isVirtualAccountFetching ? (
          <Spinner />
        ) : (
          <div className="ml-4 mr-8 sm:min-w-fit">
            <div>
              <span>Баланс: </span>
              <span className="body-bold">
                {balance}
                &nbsp;
                {ROUBLE_SIGN}
              </span>
            </div>
            <div>
              <div>
                <span>Время обновления: </span>
                <span className="body-bold">
                  {virtualAccount?.lastModificationTime &&
                    format(new Date(virtualAccount.lastModificationTime), 'dd.MM.yyyy, HH:mm')}
                </span>
              </div>
            </div>
          </div>
        )}
        <div className="my-0 w-full max-w-[290px] rounded-[10px] bg-primary-60 text-white sm:max-w-[180px]">
          <DropDown
            className="px-6"
            menuDirection={MenuDirection.BOTTOM}
            buttonMode
            button="ДЕЙСТВИЕ"
            menuItems={actions}
          />
        </div>
      </section>
      {tab === 'awaiting' &&
        (isBudgetFetching ? (
          <Spinner />
        ) : (
          <section className="flex flex-row p-5 sm:w-1/2">
            <div className="flex max-w-[650px] flex-col rounded-[10px] p-4 pr-20 shadow-3xl">
              <p className="headline-normal">
                Общая сумма вознаграждения Исполнителей:{' '}
                <span className="headline-bold">
                  {formatAmount(budgetData?.data.sumForAgent ?? 0, { minimumFractionDigits: 2 })} ₽
                </span>
              </p>
              <p className="headline-normal">
                Общая сумма комиссий:{' '}
                <span className="headline-bold">
                  {formatAmount(budgetData?.data.sumFees ?? 0, { minimumFractionDigits: 2 })} ₽
                </span>
              </p>
              <p className="headline-normal">
                Общая сумма к пополнению:{' '}
                <span className="headline-bold">
                  {formatAmount(budgetData?.data.sumForPaymentWithNBCOFee ?? 0, {
                    minimumFractionDigits: 2,
                  })}{' '}
                  ₽
                </span>
              </p>
            </div>
          </section>
        ))}
    </section>
  );
};
